
const formatAmountINR= (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (!Number.isFinite(num)) return String(value);

  const sign = num < 0 ? '-' : '';
  const [intPartRaw, decPart] = Math.abs(num).toString().split('.');

  // For Indian system: last 3 digits group first, then groups of 2
  // e.g., 12345678 -> 1,23,45,678
  const n = intPartRaw;
  if (n.length <= 3) {
    return sign + n + (decPart ? '.' + decPart : '');
  }
  const last3 = n.slice(-3);
  const head = n.slice(0, -3);
  const headGrouped = head.replace(/\B(?=(\d{2})+(?!\d))/g, ','); // insert comma every 2 digits from right
  const formatted = headGrouped + ',' + last3;

  return sign + formatted + (decPart ? '.' + decPart : '');
}

export default formatAmountINR